/**
 * CampusControls
 *
 * Camera controls wrapper with campus-specific constraints.
 * Limits zoom, rotation, and provides smooth damping.
 */

import React from 'react';
import { OrbitControls } from '@react-three/drei';

export interface CampusControlsProps {
  enableZoom?: boolean;
  enableRotate?: boolean;
  enablePan?: boolean;
  minDistance?: number;
  maxDistance?: number;
  minPolarAngle?: number;
  maxPolarAngle?: number;
  dampingFactor?: number;
}

export const CampusControls: React.FC<CampusControlsProps> = ({
  enableZoom = true,
  enableRotate = true,
  enablePan = false,
  minDistance = 30,
  maxDistance = 100,
  minPolarAngle = 0.2, // Prevent looking straight down
  maxPolarAngle = Math.PI / 2.5, // Prevent going below horizon
  dampingFactor = 0.05,
}) => {
  return (
    <OrbitControls
      enableZoom={enableZoom}
      enableRotate={enableRotate}
      enablePan={enablePan}
      minDistance={minDistance}
      maxDistance={maxDistance}
      minPolarAngle={minPolarAngle}
      maxPolarAngle={maxPolarAngle}
      enableDamping={true}
      dampingFactor={dampingFactor}
      target={[0, 0, 0]}
      makeDefault
    />
  );
};

export default CampusControls;
